import React from "react";
import { COST_ROWS } from "../../data/content";
export function CostOfInaction() {
  return <section className="bg-black py-16 px-4" data-id="element-54" data-mp="2qslyuly3wepa">
      <div className="max-w-4xl mx-auto" data-id="element-55" data-mp="2qtndt1i8tlca">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase mb-2" data-id="element-56" data-mp="2lt9ce2b5d9n8">
          ⚖️ ¿Cuánto cuesta <span className="text-[#e10600]" data-id="element-57" data-mp="2gto1qumm7cuo">no tenerlo?</span>
        </h2>
        <p className="text-center text-neutral-500 text-sm mb-8 md:hidden" data-id="element-58" data-mp="2csufe5otm63w">← Deslizá para ver la tabla completa →</p>

        <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-neutral-800" data-id="element-59" data-mp="282482mwu3t6k">
          <table className="w-full min-w-[560px] text-sm" data-id="element-60" data-mp="232hw0gsqsizc">
            <thead data-id="element-61" data-mp="230yfcp36c5x1">
              <tr className="bg-neutral-950 text-left" data-id="element-62" data-mp="1y4gcjuremhnc">
                <th className="p-4 font-condensed text-lg text-white tracking-wide" data-id="element-63" data-mp="1y6189npgg6ms">Sin Megapack 72hs™</th>
                <th className="p-4 font-condensed text-lg text-[#e10600] tracking-wide" data-id="element-64" data-mp="1t4byschvs10t">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-65" data-mp="mcp289do3124">
              {COST_ROWS.map((r, i) => <tr key={i} className={i % 2 ? "bg-black" : "bg-neutral-950/50"} data-id="element-66" data-mp="mb498o703q6d" data-mpi={i}>
                  <td className="p-4 text-neutral-300 align-top" data-id="element-67" data-mp="r5i9p50isnhw">{r.action}</td>
                  <td className="p-4 text-neutral-400 align-top" data-id="element-68" data-mp="cgca3fxrsv9h">{r.cost}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-10" data-id="element-69" data-mp="153ydoo6zzzwc">
          <p className="font-display text-2xl sm:text-3xl text-white uppercase" data-id="element-70" data-mp="15484gdzvab33">
            La próxima semana puede ser diferente.
          </p>
          <blockquote className="mt-6 font-condensed text-xl sm:text-2xl text-neutral-300 tracking-wide max-w-2xl mx-auto" data-id="element-71" data-mp="w30fimj8qmlo">
            "Tu cocina ya tiene todo lo que necesitás para empezar. El sistema es lo único que
            faltaba." 🍕
          </blockquote>
        </div>
      </div>
    </section>;
}